// Colozoo brand stores per Amazon marketplace. `lng` maps the page language to a store.

export interface Store {
  lng: string
  code: string
  domain: string
  url: string
}

export const stores: Store[] = [
  { lng: 'en', code: 'GB', domain: 'amazon.co.uk', url: 'https://www.amazon.co.uk/stores/Colozoo/page/D00BCC46-3519-4856-B012-FD748CFEE7D6' },
  { lng: 'de', code: 'DE', domain: 'amazon.de', url: 'https://www.amazon.de/stores/Colozoo/page/088F6D23-55D5-4281-ACB4-0E0BFBDD99A3' },
  { lng: 'en-US', code: 'US', domain: 'amazon.com', url: 'https://www.amazon.com/stores/Colozoo/page/C207523A-55EB-4191-B263-65E44BA822FD' },
  { lng: 'fr', code: 'FR', domain: 'amazon.fr', url: 'https://www.amazon.fr/stores/Colozoo/page/315C207E-1141-4BBF-83D1-F857DA73F838' },
  { lng: 'it', code: 'IT', domain: 'amazon.it', url: 'https://www.amazon.it/stores/Colozoo/page/6FBDACCD-D6A8-4017-971A-15D2488DE0D2' },
  { lng: 'es', code: 'ES', domain: 'amazon.es', url: 'https://www.amazon.es/stores/Colozoo/page/938FD6BE-3585-4F1E-A08F-47E8AAEC8615' },
  { lng: 'nl', code: 'NL', domain: 'amazon.nl', url: 'https://www.amazon.nl/stores/Colozoo/page/B69123A5-4AFA-4121-8636-A07CD67B15FA' },
  { lng: 'be', code: 'BE', domain: 'amazon.com.be', url: 'https://www.amazon.com.be/stores/page/0AF9CE3E-C9F7-452B-9632-B92B930C0769' },
  { lng: 'pl', code: 'PL', domain: 'amazon.pl', url: 'https://www.amazon.pl/stores/Colozoo/page/1D334B31-7C3B-4859-B475-2EAE9ED518C4' },
  { lng: 'se', code: 'SE', domain: 'amazon.se', url: 'https://www.amazon.se/stores/Colozoo/page/7DB11D18-5CEF-4567-A485-44692B2747AA' },
]

export const pickStore = (language: string): Store => {
  const exact = stores.find((s) => s.lng === language)
  if (exact) return exact
  const base = language.split('-')[0]
  return stores.find((s) => s.lng === base) || stores[0]
}
